export default function Footer() {
  return (
    <footer className="footer">
      <p> &copy; Todos los derechos reservados</p>
    </footer>
  );
}
